module.exports = __webpack_public_path__ + "static/media/welcom_img.481bb4d9.jpg";